export default {
  text: '#4c352d',
  primary: '#c1b4a9',
  secondary: '#d1dee4',
  background: '#f9f9f9',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
